
import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    Icon,
} from '@material-ui/core'

import {
    GridContainer,
    GridContainerS3smDown2,
    GridItem2sm6xs6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGrid,
    CardGridDivH4Destaque,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    ButtonDetalhesCalculo,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    GridContainerEstudoPadraoLg,
} from '../estudo-form/EstudoComp'



const EstudoFormGroupPanel = ({ title, panelList }) => {

    const classNameCardGridExterno = "pl-2 pr-2 bg-groupPanel mt-2 mb-2 border-radius-padrao"
    const classNameGridContainerS3 = "mt-2 mb-2 justify-center"
    const classNameCardGridInterno = "p-2 flex-column justify-center border-radius-padrao"
    const classNameCardGridInternoTotal = classNameCardGridInterno + " bg-groupPanelPanelTotal"
    const classNameGridItem12 = "text-center"

    return (
        <GridContainerEstudoPadraoLg
            component={
                <CardGrid
                    className={classNameCardGridExterno}
                >
                    <CardGridDivBody>
                        <GridContainer>
                            <GridItem12
                                align="center"
                            >
                                <br/>
                                <CardGridDivH4Destaque>
                                    {title}
                                </CardGridDivH4Destaque>
                            </GridItem12>
                        </GridContainer>

                        <GridContainerS3smDown2
                            className={classNameGridContainerS3}
                        >
                            {panelList?.map(
                                (item, ind) => (
                                    <GridItem2sm6xs6
                                        key={item.id}
                                    >
                                        <CardGrid
                                            className={
                                                item.total
                                                    ?
                                                        classNameCardGridInternoTotal
                                                    :
                                                        classNameCardGridInterno
                                            }
                                        >
                                            <GridContainer>
                                                <GridItem12
                                                    align="center"
                                                >
                                                    {item.icon
                                                        ?
                                                            <Icon
                                                                fontSize="large"
                                                            >
                                                                {item.icon}
                                                            </Icon>
                                                        :
                                                            <item.svgIcon
                                                                fontSize="large"
                                                            />
                                                    }
                                                </GridItem12>
                                            </GridContainer>

                                            <GridItem12
                                                className={classNameGridItem12}
                                            >
                                                {item.descricao}
                                            </GridItem12>

                                            <GridItem12
                                                className={classNameGridItem12}
                                            >
                                                <br />
                                                {item.conteudo}
                                            </GridItem12>

                                            <GridItem12>
                                                <CustomizedDialogsPopup
                                                    maxWidth='lg'
                                                    popupTitle={LABEL.buttonDetalhesCalculo}
                                                    PopupButton={ButtonDetalhesCalculo}
                                                    popupComponent={item.form}
                                                />
                                            </GridItem12>
                                        </CardGrid>
                                    </GridItem2sm6xs6>
                                )
                            )}
                        </GridContainerS3smDown2>
                    </CardGridDivBody>
                </CardGrid>
            }
        />
    )
}

export default EstudoFormGroupPanel